/**
 * PATH: packages/pricelist/src/PricelistHeaderMenus.tsx
 * FILE_ID: PKG-PRICELIST-HEADER-MENUS-001
 * PURPOSE: Desktop floating header menu OR phone MobileActionSheet for columns.
 * WHY: Phone long-press needs Hide / Manage columns as a bottom sheet twin of
 *      the desktop header context menu.
 */
import { EyeOff, SlidersHorizontal } from 'lucide-react'
import { MobileActionSheet } from '@quotech/ui/mobile'
import RowContextMenu from './RowContextMenu'
import { buildHeaderActionSheetItems } from './pricelistMobileMenus'

export interface PricelistHeaderMenuTarget {
  colKey: string
  x: number
  y: number
}

export interface PricelistHeaderMenusProps {
  isPhone: boolean
  target: PricelistHeaderMenuTarget | null
  hiding: boolean
  onHide: (colKey: string) => void
  onManage: () => void
  onClose: () => void
}

export default function PricelistHeaderMenus({
  isPhone,
  target,
  hiding,
  onHide,
  onManage,
  onClose,
}: PricelistHeaderMenusProps) {
  if (!target) return null

  if (isPhone) {
    return (
      <MobileActionSheet
        open
        onClose={onClose}
        title="Column actions"
        items={buildHeaderActionSheetItems({
          hiding,
          onHide: () => onHide(target.colKey),
          onManage,
        })}
      />
    )
  }

  return (
    <RowContextMenu
      x={target.x}
      y={target.y}
      ariaLabel="Column actions"
      items={[
        {
          key: 'hide',
          label: hiding ? 'Hiding…' : 'Hide column (all sections)',
          icon: EyeOff,
          run: () => onHide(target.colKey),
        },
        {
          key: 'manage',
          label: 'Manage columns…',
          icon: SlidersHorizontal,
          run: onManage,
        },
      ]}
      onClose={onClose}
    />
  )
}
